<script lang="ts" setup>
	const { Socials } = useStore()
	const isDialogOpen = shallowRef(false)
	const authMode = shallowRef<'register' | 'login'>('register')
	const openModal = (arg: 'register' | 'login' = 'register') => {
		authMode.value = arg
		isDialogOpen.value = true
	}
</script>

<template>
	<footer class="min-h-[1343px] relative bg-gray-900 overflow-hidden">
		<ui-pad>
			<div class="wrapper h-[inherit] py-6 sm:pt-14 flex relative z-20 flex-col items-center">
				<div class="flex items-center justify-center flex-col">
					<h3
						class="text-center font-[700] max-sm:max-w-[331px] max-sm:mx-auto text-white max-w-[436px] sm:text-[3.5em] sm:leading-[64px] text-[2em] xs:text-[2.5em]"
					>
						Insurance that actually
						<span class="text-base-primary">works!</span>
					</h3>
					<ui-btn
						name="get onboarded"
						class="mt-8 text-white bg-main hover:bg-base-primary sm:h-[56px] h-[50px]"
						:ui="{
							btn: {
								onHoverPseudo: 'hover:before:bg-base-primary'
							},
							text: {
								size: 'text-sm md:text-base'
							}
						}"
						@click="openModal('register')"
					>
						Get Covered Now
					</ui-btn>
				</div>

				<ui-wrapper class="mx-auto w-full">
					<footer-links @login="openModal('login')" />

					<div
						class="mt-12 pb-20 border-b border-gray-500 w-full flex flex-col sm:block justify-center items-center"
					>
						<tools-icon
							dir="internal-logo"
							icon="mcg-logo-mixed"
							width="190"
							height="48"
							svg-class="hidden sm:block"
						/>
						<tools-icon dir="internal-logo" icon="cap-round" width="64" height="64" svg-class="sm:hidden" />

						<div
							class="flex items-end justify-center sm:justify-between w-full flex-wrap pt-10 text-gray-300"
						>
							<div>
								<div class="flex flex-col justify-center sm:justify-normal sm:w-auto w-full flex-none">
									<p
										class="maitree-regular text-xl sm:max-w-[357px] max-w-[335px] mx-auto sm:mx-0 sm:text-left text-center sm:leading-[32px]"
									>
										Redefining the insurance experience for Nigerians.
									</p>
								</div>
								<img
									src="~/assets/img/ndpr.png"
									class="md:w-[110px] h-[100px] max-w-[110px] w-full mx-auto object-contain mt-[20px] md:mt-[12px] rounded bg-white overflow-hidden sm:mx-0"
									loading="lazy"
									alt="NDPR - Nigeria Data Protection Regulation Compliance"
								/>
							</div>

							<div class="w-">
								<div class="items-center gap-x-6 sm:flex hidden pb-5 justify-end relative">
									<a
										v-for="(item, index) in Socials"
										:href="item.url ?? ''"
										target="_blank"
										rel="noopener noreferrer"
										:key="index"
										:aria-label="`Follow MyCoverGenius on ${item.label}`"
										class="flex-none group"
									>
										<tools-icon
											:icon="item.iconName"
											dir="socials"
											class="group-hover:opacity-0 group-hover:absolute bottom-0"
											:height="34"
											:width="30"
										/>
										<tools-icon
											:icon="item.active"
											dir="socials"
											class="transition ease-linear group-hover:opacity-100 group-hover:inline hidden"
											:height="34"
											:width="30"
										/>
									</a>
								</div>
								<p class="text-sm hidden sm:block">
									© {{ new Date().getFullYear() }} | MyCovergenius | All Rights Reserved
								</p>
								<p
									class="pt-5 inline-flex w-full justify-center sm:justify-end text-right items-center gap-x-2 text-sm"
								>
									Made with <tools-icon dir="fill" icon="heart" /> from Nigeria
								</p>
							</div>
						</div>
					</div>

					<div
						class="pt-16 w-full flex flex-wrap sm:flex-nowrap items-end justify-between gap-x-8 text-gray-400"
					>
						<p class="sm:max-w-[718px] pb-10 text-sm sm:pb-0">
							Disclaimer: MyCoverGenius is not an insurance company, we partner with leading and regulated
							insurance companies in Nigeria to make insurance affordable and accessible for businesses
						</p>

						<molecules-providers class="sm:mr-auto w-full sm:w-[unset]" />
					</div>
					<p class="text-sm sm:hidden py-5 text-gray-400">
						© {{ new Date().getFullYear() }} | MyCovergenius | All Rights Reserved
					</p>
				</ui-wrapper>
			</div>
		</ui-pad>

		<div class="absolute top-0 pointer-events-none z-[1]">
			<tools-icon
				svg-class="w-[557.22px] h-[351.85px] sm:w-[100vw] sm:h-[60vh] lg:h-[866px] absolute -left-[90.66px] md:static -top-[3.15px] block"
				dir="internal-logo"
				icon="mcg-cap-lg"
				width="1439"
				height="866"
				class="pointer-event-none"
			/>
		</div>
		<molecules-auth-dialog v-model="isDialogOpen" :selected="authMode" />
	</footer>
</template>
